export default __webpack_public_path__ + "static/media/howIllustration.f9ecc34f.png";